





















































































































const namespace = 'workshopsSchedule';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import RestResource from '@/modules/api/RestResource';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import IPaymentRequest from '@/modules/form/interfaces/IPaymentRequest';
import LocaleSwitcher from '@/components/LocaleSwitcher.vue';
import { WeekDay, WeekSchedule, Workshop, Timeline } from '@/modules/workshops-schedule/models/weekScheduleModels';
import {
    Registration,
    AvailableTicketType,
    RegistrationCancellation,
} from '@/modules/workshops-schedule/models/formModels';
import { FormHelper } from '@/modules/workshops-schedule/models/logic/FormHelper';
import { generateClientIP } from '@/utils/web';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

@Component({
    name: 'EventRegistrationCancellation',
    components: {
        ValidationProvider,
        ValidationObserver,
        LocaleSwitcher,
    },
})
export default class EventRegistrationCancellation extends Vue {
    @Getter('loading', { namespace }) private loading!: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setLoading', { namespace }) private setLoading: any;
    @Getter('isGuidelineVisible', { namespace: 'workshopsSchedule' }) private isGuidelineVisible!: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('showGuideline', { namespace }) private showGuideline: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('hideGuideline', { namespace }) private hideGuideline: any;
    @Getter('currentEventId', { namespace: 'form' }) private currentEventId!: number;
    @Getter('weekSchedule', { namespace }) private weekSchedule!: WeekSchedule;
    @Getter('weekDays', { namespace }) private weekDays!: WeekDay[];
    @Getter('workshops', { namespace }) private workshops!: Workshop[];
    @Getter('timeline', { namespace }) private timeline!: Timeline[];
    @Getter('apiUrl', { namespace: 'configuration' }) private apiUrl!: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setEvents', { namespace: 'calendar' }) private setEvents: any;
    @Getter('getAllEvents', { namespace: 'calendar' }) private getAllEvents!: ICalendarData[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setWeekSchedule', { namespace }) private setWeekSchedule: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('fetchAvaiableTicketTypes', { namespace }) private fetchAvaiableTicketTypes: any;
    @Action('fetchCurrentWeekDays', { namespace }) private fetchCurrentWeekDays: any;
    @Action('setFormDetails', { namespace }) private setFormDetails: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('loadFormStateForRegistration', { namespace }) private loadFormStateForRegistration!: any;
    @Getter('availableTicketsTypes', { namespace }) private availableTicketsTypes!: AvailableTicketType[];
    @Getter('availableTicketsIds', { namespace }) private availableTicketsIds!: number[];
    @Getter('selectedWorkshopsIds', { namespace }) private selectedWorkshopsIds!: number[];
    @Getter('selectedTicketsIds', { namespace }) private selectedTicketsIds!: number[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('tooglSelectedWorkshopId', { namespace }) private tooglSelectedWorkshopId: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('toogleSelectedTicket', { namespace }) private toogleSelectedTicket: any;
    private get cssVariables() {
        return (
            '--weekday-width:' +
            100 / this.weekSchedule.WeekDays.length +
            '%; ' +
            '--location-width:' +
            100 / this.weekSchedule.WeekDays[0].Locations.length +
            '%; ' +
            '--room-width:' +
            100 / this.weekSchedule.WeekDays[0].Locations[0].Rooms.length +
            '%; ' +
            '--schedule-board-container-height: 1000px;'
        );
    }

    private getTranslation(key: string) {
        return this.$t(key).toString();
    }

    //#region form
    private eventId = 0;
    private formStep = 1;
    private alertsVisible = false;
    private errors: any[] = [];
    private alerts: object[] = [];
    private formHelper = new FormHelper();
    private sexItems = [
        { value: 1, text: this.getTranslation('userForm.male') },
        { value: 2, text: this.getTranslation('userForm.female') },
    ];
    private selectedReason = '';
    private reasons = [
        { value: 'Date', text: this.getTranslation('cancellationForm.Date') },
        { value: 'Not interested workshops', text: this.getTranslation('cancellationForm.Not interested workshops') },
        { value: 'Price', text: this.getTranslation('cancellationForm.Price') },
        { value: 'Other', text: this.getTranslation('cancellationForm.Other') },
    ];
    private reasonTextareaActive = false;

    private onSelectedReasonChanged(event: any) {
        if (this.selectedReason === 'Other') {
            this.reasonTextareaActive = true;
            this.registrationCancellation.reason = '';
        } else {
            this.reasonTextareaActive = false;
            this.registrationCancellation.reason = this.selectedReason;
        }
    }

    public async mounted() {
        const eventId =
            this.$route.query.e ||
            this.$route.query.eventId ||
            this.$route.query.EventId ||
            this.currentEventId.toString();
        if (eventId !== undefined) {
            this.eventId = +eventId as number;
        }

        generateClientIP();

        this.registartionCancellationsResource.$on('resourceCreated', this.onRegistartionCancellationCreated);
        this.registartionCancellationsResource.baseUrl = this.apiUrl + '/registrations/EventRegistrationCancellations';

        if (this.isSessionContinuation) {
            const eventRegistrationId = +this.$route.query.i as number;
            const eventRegistrationGuid = this.$route.query.g as string;

            this.setFormDetails({
                eventRegistrationId: eventRegistrationId,
                eventRegistrationGuid: eventRegistrationGuid,
            });

            const form = await this.loadFormStateForRegistration();
            this.form = form as Registration;
        }
    }

    private get isSessionContinuation() {
        return this.$route.query.g !== undefined && this.$route.query.i !== undefined;
    }

    private cleanUrlParameters() {
        window.history.replaceState(null, '', '/');
    }

    private readonly SubmitEventRegistrationCancellation =
        this.apiUrl + '/registrations/EventRegistrationCancellations';
    private registartionCancellationsResource: RestResource<RegistrationCancellation> = new RestResource<
        RegistrationCancellation
    >(this.SubmitEventRegistrationCancellation, this.onResourceLoading, this.onResourceLoadingFinished, this.onError);
    private readonly PaymentRequests = this.apiUrl + '/payments/PaymentRequests';
    private paymentsResource: RestResource<IPaymentRequest> = new RestResource<IPaymentRequest>(
        this.PaymentRequests,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );

    private registrationCancellation: RegistrationCancellation = {
        eventRegistrationId: 0,
        eventRegistrationGuid: '',
        reason: '',
    };

    private form: Registration = this.formHelper.createEmptyRegistrationForm(this.eventId);

    private get ticketsSelected(): boolean {
        return this.selectedWorkshopsIds.length < 1;
    }

    private get eventParticipantSexTypeId(): number | null {
        return this.form.ParticipantData.SexTypeId.Value;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onError(data: any) {
        console.error(data);
        this.errored = true;
        if (data.error !== undefined) {
            this.showError(data.error.message);
        } else {
            this.showError("We can't submit your form. Please try again later or contact with the administrator.");
        }
    }

    private showError(message: string) {
        this.alerts.push({ type: 'error', message: message });
        this.alertsVisible = true;
    }

    private showWarning(message: string) {
        this.alerts.push({ type: 'warning', message: message });
        this.alertsVisible = true;
    }

    private showInfo(message: string) {
        this.alerts.push({ type: 'info', message: message });
        this.alertsVisible = true;
    }

    private showSuccess(message: string) {
        this.alerts.push({ type: 'success', message: message });
        this.alertsVisible = true;
    }

    private closeAlerts() {
        this.alertsVisible = false;
        this.alerts = [];
    }

    private async submitRegistrationForm() {
        const observer = this.$refs.observer as any;
        await observer.validate();
    }

    private async submit() {
        const observer = this.$refs.observer as any;
        const result = await observer.validate();
        if (!result) {
            return;
        }

        this.registrationCancellation.eventRegistrationId = this.form.EventRegistrationId;
        this.registrationCancellation.eventRegistrationGuid = this.form.EventRegistrationGuid;
        await this.registartionCancellationsResource.createNewResource(this.registrationCancellation);
    }

    private async onRegistartionCancellationCreated(response: any) {
        // this.$router.currentRoute.query;
        // let path = `${window.location.origin}${window.location.pathname}${this.$router.currentRoute.fullPath}`;
        let path = `${window.location.origin}${window.location.pathname}`;
        path = path.replace('//?', '?').replace('/?', '?');

        if (response) {
            this.cleanUrlParameters();
            this.showInfo('Your registration has been cancelled.');
            this.clear();

            return;
        } else {
            this.showError('Error during requesting cancellation. Please try again or contact with the administrator.');
        }
    }

    private get clientIp() {
        let clientIp = localStorage.getItem('clientIp');
        if (clientIp === undefined || clientIp === null || clientIp === '' || clientIp === 'undefined') {
            clientIp = '127.0.0.1'; // fake IP in case of issuses with getting parameter that is required for the payent
        }

        return clientIp;
    }

    private clear() {
        this.registrationCancellation.eventRegistrationId = 0;
        this.registrationCancellation.eventRegistrationGuid = '';
        this.registrationCancellation.reason = '';
        this.selectedReason = '';

        this.formHelper.clearRegistrationForm(this.form);

        this.clearSelectedTickets();

        (this.$refs.observer as any).reset();
        this.formStep = 1;
    }

    private clearSelectedTickets() {
        this.selectedTicketsIds?.forEach(ticketId => {
            this.toogleSelectedTicket(ticketId);
            this.selectedTicketsIds.splice(this.selectedTicketsIds.indexOf(ticketId), 1);
        });
        this.form.ParticipantData.SelectedTickets.Value = [];
    }

    //#endregion form

    private errorMessage = '';
    private errored = false;

    private onResourceLoading() {
        this.setLoading(true);
    }

    private onResourceLoadingFinished() {
        this.setLoading(false);
    }

    private getImageUrl(url: string) {
        if (url === undefined) {
            return '';
        }
        const pluginDirectory = process.env.VUE_APP_IMAGES_DIR;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const imgUrl = require(`@/assets${url}`);
        return this.isWordPressPlugin && !imgUrl.startsWith('data:image/jpeg;base64')
            ? pluginDirectory + imgUrl
            : imgUrl;
    }

    protected get isWordPressPlugin() {
        return process.env.VUE_APP_IS_WORDPRESS_PLUGIN === 'true';
    }
}
